module.exports = __webpack_public_path__ + "static/media/image51.23f1610d.png";